import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import dataModel from '../../models/DataModel';
import eventBus from '../../helpers/EventBus';
import './ProjectTemplateAdd.scss';
import MarketComboBox from '../../components/MarketComboBox';
import CheckBox from '../../components/CheckBox';
import closeButton from '../../assets/images/cancel-icon-gray.svg';
import marketsService from '../../services/marketsService.js';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import Input from '../Input/index.js';

const projectTemplateDescriptor = {
  project_template: {
    markets: {},
    company_closeout_template: {},
  },
};

export class ProjectTemplateAdd extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      project_templateName: props.templateEditInfo ? props.templateEditInfo.templateName : '', 
      // closeoutTemplateId: this.determineCloseoutTemplateOption(),
      selectedMarkets: props.templateEditInfo ? props.templateEditInfo.templateMarkets : null,
      duration: props.templateEditInfo ? props.templateEditInfo.duration : false,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.inputField) {
      this.inputield.focus();
    }
  }

  handleAddProjectTemplate() {
    let validated = this.handleValidation(this.state.project_templateName, this.props.templateEditInfo);
    if (validated) {
      dataModel.projectTemplatesDAO.createProjectTemplate({ 
        name: this.state.project_templateName, 
        company: this.props.selectedCompany, 
        project_type: this.props.selectedProjectType, 
        company_closeout_template_id: this.state.closeoutTemplateId,
        config: { duration: this.state.duration },
      }, 
        {
          recordDescriptor: projectTemplateDescriptor,
        }).then((newProjectTemplate) => {
          this.analyticsLogger.logProjectTemplateEvent(newProjectTemplate, 'ProjectTemplateCreated');
          if (this.props.handleAddProjectTemplate) {
            this.props.handleAddProjectTemplate(newProjectTemplate);
          }
          eventBus.emit('templateCreated', { newTemplate: newProjectTemplate });
          if (this.state.selectedMarkets && this.state.selectedMarkets.length > 0) {
            const marketPromises = this.state.selectedMarkets.map((market) => {
              return marketsService.addProjectTemplateToMarket(newProjectTemplate, market.id);
            });
            Promise.all(marketPromises).then(result => {
              this.props.history.push('/project-types/' + newProjectTemplate.project_type_id + '/project-template/' + newProjectTemplate.id);
            });
          } else {
            this.props.history.push('/project-types/' + newProjectTemplate.project_type_id + '/project-template/' + newProjectTemplate.id);
          }
        });
      this.handleCancel();
    }
  }
  
  handleCancel() {
    const { closeAddCard } = this.props;
    if (closeAddCard) {
      closeAddCard();
    }
  }

  handleCloseAnimation() {
    if (this.props.closeAddCard) {
      this.props.closeAddCard();
    }
  }

  handleChange(e) {
    this.setState({ project_templateName: e.target.value });
  }

  handleKeyDown(e) {
    const { editing } = this.props;
    if (e.keyCode == 13 || e.keyCode == 40) {
      if (editing) this.handleUpdateProjectTemplate();
      else this.handleAddProjectTemplate();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  } 

  handleUpdateProjectTemplate() {
    const validated = this.handleValidation(this.state.project_templateName, this.props.templateEditInfo, true);
    if (validated) {
      const { project_templateName, selectedMarkets, closeoutTemplateId, duration } = this.state;
      this.props.handleUpdateProjectTemplate(project_templateName, selectedMarkets, closeoutTemplateId, { duration: duration });
    }
  }

  handleValidation(name, templateEditInfo, forUpdate){
    if (name && name.trim().length > 0) {
      if (this.props.existingTemplates && !forUpdate) {
        const foundTemplate = this.props.existingTemplates.find((existingTemplate) => {
          return existingTemplate.name.toLowerCase() == name.toLowerCase();
        });
        if (foundTemplate && (!templateEditInfo || (templateEditInfo.templateId != foundTemplate.id))) {
          this.props.dataModel.displayInfoErrorMessage(this.textMap.projectTemplateNameExists, 4000, 2);
          return false;
        }
      }
      return true;
    }
    this.props.dataModel.displayInfoErrorMessage(this.textMap.projectTemplateNameRequired, 4000, 2);
    return false;
  }

  handleMarketChange(markets) {
    let tempMarkets = markets ? markets.map(m => {
      m.market.toBeAdded = true;
      return m.market;
    }): [];

    this.setState({ selectedMarkets: tempMarkets });
  }

  handleCloseoutTemplateSelection(type, option) {
    if (this.state.project_templateName.length && this.state.selectedMarkets.length) {
      this.setState({ closeoutTemplateId: option.type });
    } else {
      this.setState({ closeoutTemplateId: option.type });
    }
  }

  determineCloseoutTemplateOption() {
    const { editing, templateEditInfo, closeoutTemplates } = this.props;

    //if editing use the template closeout id of the project template
    if (editing) {
      return templateEditInfo.templateCloseout.id;
    }
    //if not editing, choose the first closeout from all of the closeout templates
    if (closeoutTemplates && closeoutTemplates.length) {
      const standardTemplate = closeoutTemplates.find(template => template.name.toLowerCase().trim() == 'standard');
      return standardTemplate.id || closeoutTemplates[0].id;
    }
    return null;
  }

  handleDurationToggle(checked) {
    this.setState({ duration: checked });
  }

  marketsDiffer() {
    const { templateEditInfo } = this.props;
    // we are editing... compare existing markets against current market list
    if (templateEditInfo.templateMarkets.length != this.state.selectedMarkets.length) {
      return true;
    }
    return templateEditInfo.templateMarkets.filter((existingMarket) => {
      return this.state.selectedMarkets.find((newMarket) => {
        return existingMarket.id == newMarket.id;
      });
    }).length != this.state.selectedMarkets.length;
  }

  canAddOrUpdate(editing) {
    if (!editing 
        && this.state.selectedMarkets && this.state.selectedMarkets.length > 0
        && this.state.project_templateName) {
      return true;
    }
    else if (this.props.templateEditInfo) {
      
      if (this.state.project_templateName != this.props.templateEditInfo.templateName
          || this.state.duration != this.props.templateEditInfo.duration
          || this.marketsDiffer()) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { markets, version, currentCompany } = this.props;

    const canAdd = this.canAddOrUpdate(this.props.editing);

    // const closeoutTemplateOptions = closeoutTemplates ? closeoutTemplates.map(closeoutTemplate => {
    //   return {type: closeoutTemplate.id, name: closeoutTemplate.name}
    // }) : []
    // const closeoutIndex = closeoutTemplateOptions.findIndex(closeout => closeout.type == this.state.closeoutTemplateId)
    // const closeoutTemplateOption = closeoutTemplateOptions[closeoutIndex]

    return (
      // Replace with the appropriate HTML
      <div className={'project-template-add'} id={this.props.id}>
        <div className='project-template-label'>PROJECT TEMPLATE</div>
        <div className='project-template-name-input-container'>
          <Input 
            className='project-template-name-input' 
            placeholder="Project Template Name" 
            onChange={this.handleChange} 
            onKeyDown={this.handleKeyDown} 
            value={this.state.project_templateName}
            disabled={this.props.editing && !this.props.templateEditInfo.templateNameEditable}
          />
        </div>
        <div className='markets-label'>MARKETS</div>
        <div className='markets-combo'>
          <MarketComboBox 
            handleSelectMarket={this.handleMarketChange}
            markets={markets}
            currentOption={this.state.selectedMarkets}
            height={24}
            width={145}
            hasBorder={false}
            multiSelect={true}              
            defaultText={this.textMap.markets}
            selectDefault={false}
            displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '5px', marginTop: '5px' }}
          />
        </div>
        <div className="version-label">VERSION NUMBER</div>
        <div className="version-input-container">
          <span className="version-input" >{'Version '+version}</span>
        </div>
        <div className="buttons">
          {
            !this.props.editing &&
            <div className={'add-button' + (!canAdd ? ' disabled' : '')} onClick={this.handleAddProjectTemplate}>{this.textMap.add.toUpperCase()}</div>
          }
          {
            this.props.editing &&
            <div className={'edit-button' + (!canAdd ? ' disabled' : '')} onClick={this.handleUpdateProjectTemplate}>{this.textMap.save.toUpperCase()}</div>
          }
          <img className="cancel-button" onClick={this.handleCancel} src={closeButton} alt="closebutton"/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectTemplateAdd));



// WEBPACK FOOTER //
// ./src/components/ProjectTemplateAdd/index.js